import { IGetConstructionProgressResponseSchema } from '../repositories/construction-progress/entities/get_construction_progress_page/GetConstructionProgressResponseSchema';
import { IGetConstructionProgressResponse } from '../types/constructionProgress';
import { prepareConstructionProgress } from './constructionProgress/prepareConstructionProgress';

export function transformConstructionProgressResponse({
  isLast,
  newbuildingName,
  totalImagesCount,
  constructionProgress,
}: IGetConstructionProgressResponseSchema): IGetConstructionProgressResponse {
  return {
    isLast,
    newbuildingName,
    totalImagesCount,
    constructionProgress: constructionProgress.map(item => prepareConstructionProgress(item, newbuildingName)),
  };
}
